import api from './api'

const varietyDataProvider = {
  getVarietyTable(params) {
    return api.post('Product/api/Category/GetCategoryPropertiesTable', params)
  },
  getVarietyData(params = {}) {
    return api.query('Product/api/Category/GetCategoryProperties', { params })
  },
  addVariety(params) {
    return api.post('Product/api/Category/AddPropertyCategory', params)
  },
}

export default varietyDataProvider
